import { toTimestamp } from "@app/components/Dashboard/utils/timestamp";
import { Tabs, TabsList, TabsTrigger, TabsContent } from "@shortsworks/ui";
import {
  useGetReportForStoriesReportStoriesGet,
  useGetReportForGroupsReportGroupsGet,
} from "@shortsworks/user-api";
import { ShortsworksTable } from "../../DashboardTable";
import {
  ColumnDef,
  OnChangeFn,
  RowSelectionState,
} from "@tanstack/react-table";
import { postingGroupReportColumns, postingReportColumns } from "./columns";
import { useDashboardContext } from "../../DashboardProvider";
import { useState } from "react";

export type TableProps<T> = {
  name: string;
  columns: ColumnDef<T>[];
  noDataMessage?: string;
  useMinHeight?: boolean;
};

export const DetailListSection = () => {
  const {
    timeWindow,
    customDateRange,
    dataIsEmpty,
    groupFilter,
    setGroupFilter,
  } = useDashboardContext();
  const [activeTab, setActiveTab] = useState<string>("posting");
  const {
    data: postingData,
    isLoading: isLoadingPosting,
    isSuccess: isSuccessPosting,
  } = useGetReportForStoriesReportStoriesGet({
    time_window: timeWindow,
    start_date: customDateRange
      ? toTimestamp(customDateRange.startDate)
      : undefined,
    end_date: customDateRange
      ? toTimestamp(customDateRange.endDate)
      : undefined,
    group_ids: groupFilter?.map((group) => group.id) || [],
  });

  const {
    data: postingGroupData,
    isLoading: isLoadingPostingGroup,
    isSuccess: isSuccessPostingGroup,
  } = useGetReportForGroupsReportGroupsGet({
    time_window: timeWindow,
  });

  // useEffect(() => {
  //     if (timeWindow === 'custom' && !customDateRange) {
  //         return;
  //     }
  //
  //     if (activeTab === 'posting') {
  //         setPostingReportPrams({
  //             timeWindow,
  //             startDate: customDateRange ? toTimestamp(customDateRange.startDate) : undefined, endDate: customDateRange ? toTimestamp(customDateRange.endDate) : undefined,
  //             groupIds: groupFilter?.map(group => group.id) || [],
  //         });
  //     } else {
  //         setPostingGroupReportPrams({
  //             timeWindow,
  //             startDate: customDateRange ? toTimestamp(customDateRange.startDate) : undefined,
  //             endDate: customDateRange ? toTimestamp(customDateRange.endDate) : undefined,
  //         });
  //     }
  // }, [timeWindow, customDateRange, activeTab, groupFilter]);
  const handleChangeTab = (value: string) => {
    setActiveTab(value);
  };

  const handleGroupRowSelectionChange: OnChangeFn<RowSelectionState> = (
    updater,
  ) => {
    // @ts-ignore
    setGroupFilter?.(() => {
      const data = groupFilter?.reduce(
        (acc, curr) => {
          acc[curr.id] = true;
          return acc;
        },
        {} as Record<string, boolean>,
      );

      const newPaginationValue =
        updater instanceof Function ? updater(data || {}) : updater;

      return Object.keys(newPaginationValue)
        .sort((a, b) => b.localeCompare(a))
        .map((key) => {
          // @ts-ignore
          const group = postingGroupData.data.find((group) => group.id === key);
          return { id: key, name: group?.name };
        });
    });
  };

  const getGroupRowSelection = () => {
    return groupFilter?.reduce(
      (acc, curr) => {
        acc[curr.id] = true;
        return acc;
      },
      {} as Record<string, boolean>,
    );
  };

  if (dataIsEmpty) return null;

  return (
    <div className="flex-auto overflow-hidden min-h-20 mt-1">
      <Tabs
        value={activeTab}
        onValueChange={handleChangeTab}
        style={{ height: "650px" }}
      >
        <TabsList
          style={{
            display: "grid",
            width: "100%",
            gridTemplateColumns: "repeat(2, minmax(0, 1fr))",
            marginBottom: "10px",
          }}
        >
          <TabsTrigger value="posting">포스팅</TabsTrigger>
          <TabsTrigger value="group">그룹</TabsTrigger>
        </TabsList>
        <TabsContent
          value="posting"
          style={{ border: "1px solid #E2E8F0", height: "100%" }}
        >
          {activeTab === "posting" && isLoadingPosting && (
            <div className="flex items-center justify-center h-full">
              Loading...
            </div>
          )}
          {activeTab === "posting" &&
          isSuccessPosting &&
          postingData?.data &&
          postingData?.data.length > 0 ? (
            <ShortsworksTable
              id="storyTable"
              rowIdKey="storyId"
              columns={postingReportColumns}
              data={postingData?.data || []}
            />
          ) : (
            <div className="flex items-center justify-center w-screen h-screen">
              데이터가 없습니다.
            </div>
          )}
        </TabsContent>
        <TabsContent
          value="group"
          style={{ border: "1px solid #E2E8F0", height: "100%" }}
        >
          {activeTab === "group" && isLoadingPostingGroup && (
            <div className="flex items-center justify-center h-full">
              Loading...
            </div>
          )}
          {activeTab === "group" &&
          isSuccessPostingGroup &&
          postingGroupData?.data &&
          postingGroupData?.data.length > 0 ? (
            <ShortsworksTable
              id="groupTable"
              rowIdKey="id"
              columns={postingGroupReportColumns}
              data={postingGroupData?.data || []}
              enableRowSelection={true}
              rowSelection={getGroupRowSelection()}
              onRowSelectionChange={handleGroupRowSelectionChange}
            />
          ) : (
            <div className="flex items-center justify-center w-screen h-screen">
              데이터가 없습니다.
            </div>
          )}
        </TabsContent>
      </Tabs>
    </div>
  );
};
